import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { SidebarContext } from '../../../../context/SidebarContext';
import { useCompanySectionFilter } from '../../../../component/B2B/CompanySectionLayout';
import { fetchCompanyGameDetail } from './companyGamesApi';

/**
 * The container every per-game tab shares. The four pages differ only in which
 * game they ask for and what the browser tab says, so one factory keeps the
 * scoping — token, B2B/Members toggle, department filter — defined once rather
 * than in four near-identical copies that could drift apart.
 */
const CGamePage = ({ gameKey, title, page: Page }) => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const { department } = useCompanySectionFilter();

  const fetcher = useCallback(
    () => fetchCompanyGameDetail(gameKey, department),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [gameKey, isB2BFansMode, department]
  );

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{title} | Shoorah</title>
      </Helmet>
      <Page fetcher={fetcher} populationLabel={isB2BFansMode ? 'members' : 'employees'} />
    </div>
  );
};

CGamePage.propTypes = {
  gameKey: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  page: PropTypes.elementType.isRequired
};

export default CGamePage;
